import toast from "react-hot-toast";
import axios from "../axios";
import { ReportCommentAPIresponse } from "./reports/parseReports";

export const getReportComments = async (reportId: number | undefined) => {
  try {
    if (!reportId) {
      return;
    }
    const res = await axios.get(`/v2/reports/comments/?reportId=${reportId}`);
    if (res.status === 200) {
      const data: object[] = [];
      res.data.forEach((item: ReportCommentAPIresponse) => {
        data.push(item);
      });
      return data;
    }
  } catch (error) {
    console.log("error at /v2/reports/comments");
    console.log(error);
    toast.error("An error occured, please try again");
  }
};

export const createReportComment = async (
  reportId: number,
  userComment: string
) => {
  try {
    if (!reportId) {
      toast.error("ERROR TRY AGAIN");
      return;
    } else {
      if (userComment.length === 0) {
        toast.error("Cannot send empty as comment");
      } else {
        const res = await axios.post(`/v2/reports/comments`, {
          id: reportId,
          comment: userComment
        });
        res.status === 200
          ? toast.success("Added new comment")
          : toast.error("Server side error, try again");
      }
    }
  } catch (error) {
    console.log("error at /v2/reports/comments -  post comment");
    console.log(error);
    toast.error("An error occured, please try again");
  }
};

export const deleteReportComment = async (commentId: number | undefined) => {
  try {
    if (!commentId) {
      toast.error("something went wrong try again");
    } else {
      const res = await axios.delete(`/v2/reports/comments/delete-comment`, {
        data: { comment_id: commentId }
      });
      res.status === 200
        ? toast.success("Deleted comment")
        : toast.error("server side error, try again");
    }
  } catch (error) {
    console.log("error at /v2/reports/comments/delete-comments");
    console.log(error);
    toast.error("An error occured, please try again");
  }
};

export const editReportComment = async (commentId: number, comment: string) => {
  try {
    if (!commentId) {
      toast.error("Something went wrong, Please try again");
      return;
    } else {
      if (comment.length === 0) {
        toast.error("Cannot edit comment to empty. Did you mean to Delete? ");
      } else {
        const res = await axios.post("/v2/reports/comments/edit-comment", {
          comment_id: commentId,
          newComment: comment
        });
        res.status === 200
          ? toast.success("Comment edited")
          : toast.error("Server side error, please try again");
      }
    }
  } catch (error) {
    console.log("error at /v2/reports/comments/edit-comment");
    console.log(error);
    toast.error("An error occured, please try again");
  }
};

export interface CommentsFeedItem {
  comment_id: string | number;
  comment: string;
  createdAt: string;
  postedBy: string;
  pfp: string;
  vulnerabilityName: string;
  severityCategory: string;
  programName: string;
  orgName: string;
  reportId: number;
  retestId?: number;
  runTitle?: string | null;
  runType?: string | null;
  feedType?: string;
  previousStatus?: string;
  newStatus?: string;
  poc?: string | null;
}

export interface CommentsFeedResponse {
  count: number;
  comments: CommentsFeedItem[];
}

export const getCommentsFeed = async (params: {
  program?: string;
  severity?: string;
  startDate?: string;
  endDate?: string;
  company?: string;
  roleGroup?: string;
  feedTypes?: string;
  page?: number;
  limit?: number;
  search?: string;
}): Promise<CommentsFeedResponse | undefined> => {
  try {
    const queryParts: string[] = [];
    if (params.program) queryParts.push(`program=${params.program}`);
    if (params.severity) queryParts.push(`severity=${params.severity}`);
    if (params.startDate) queryParts.push(`startDate=${params.startDate}`);
    if (params.endDate) queryParts.push(`endDate=${params.endDate}`);
    if (params.company) queryParts.push(`company=${params.company}`);
    if (params.roleGroup) queryParts.push(`roleGroup=${params.roleGroup}`);
    if (params.feedTypes) queryParts.push(`feedTypes=${params.feedTypes}`);
    if (params.page) queryParts.push(`page=${params.page}`);
    if (params.limit) queryParts.push(`limit=${params.limit}`);
    if (params.search) queryParts.push(`search=${encodeURIComponent(params.search)}`);

    const queryString = queryParts.length > 0 ? `?${queryParts.join("&")}` : "";
    const res = await axios.get(`/v2/reports/comments/feed${queryString}`);
    if (res.status === 200) {
      return res.data;
    }
  } catch (error) {
    console.log("error at /v2/reports/comments/feed");
    console.log(error);
    toast.error("An error occurred fetching comments, please try again");
  }
};
